import { AvailabilityRequestAssignment, TimeOfDay } from "./self-schedule";

export enum WaitlistStatus {
  WAITING = "WAITING",
  CONTACTED = "CONTACTED",
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
}

export interface WaitlistPatientRef {
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface WaitlistProviderRef {
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface WaitlistAssignment extends AvailabilityRequestAssignment {
  /** Any one of these providers will do: two or more, only when providerId is null. */
  providerIds?: string[];
}

export interface WaitlistEntry {
  id: string;
  patientId: string;
  assignments: WaitlistAssignment[];
  addonSelections?: Record<string, string[]>;
  startDate: string;
  endDate: string;
  timePreference?: TimeOfDay | null;
  notes: string | null;
  status: WaitlistStatus;
  locationId: string | null;
  locationName?: string | null;
  creatorId: string;
  createdDate: string;
  updatedDate: string | null;
  patient: WaitlistPatientRef | null;
  providers: WaitlistProviderRef[];
  services: { id: string; name: string }[];
  /** Complete eligibility on alerts/CRUD; query-relative metadata on list projections. */
  matchingProviderIds?: string[] | null;
}

export interface WaitlistUpdateData {
  waitlistId: string;
  entry: WaitlistEntry | null;
  locationId: string | null;
}

export interface WaitlistCreate {
  patientId: string;
  assignments: WaitlistAssignment[];
  addonSelections?: Record<string, string[]>;
  startDate: string;
  endDate: string;
  timePreference?: TimeOfDay | null;
  notes?: string;
  locationId?: string | null;
}

export interface WaitlistUpdate {
  status?: WaitlistStatus;
  timePreference?: TimeOfDay | null;
  notes?: string;
  startDate?: string;
  endDate?: string;
  assignments?: WaitlistAssignment[];
  addonSelections?: Record<string, string[]>;
  locationId?: string | null;
}
